'use strict';

var React = require('react');

var PhoneNumber = function PhoneNumber(_ref) {
    var number = _ref.number;
    var isLinked = _ref.isLinked;
    var className = _ref.className;

    number = number.toString().replace(/[^0-9\+]+/g, '').replace(/\s+/, '');

    var formatted_number = void 0;

    if (number.length == 8) {
        formatted_number = number.replace(/([0-9]{2})([0-9]{3})([0-9]{3})/, "$1 $2 $3");
    } else if (number.length == 10) {
        formatted_number = number.replace(/([0-9]{4})([0-9]{3})([0-9]{3})/, "$1 $2 $3");
    } else if (number.indexOf('+') == 0) {
        formatted_number = number.replace(/([0-9]{2})([0-9]{3})([0-9]{3})([0-9]{3})/, "$1 $2 $3 $4");
    }

    if (isLinked) {
        return React.createElement(
            'a',
            { href: 'tel:' + number, className: className },
            formatted_number
        );
    } else {
        return React.createElement(
            'span',
            { className: className },
            formatted_number
        );
    }
};

PhoneNumber.propTypes = {
    number: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]).isRequired,
    isLinked: React.PropTypes.bool,
    className: React.PropTypes.string
};

PhoneNumber.defaultProps = {
    isLinked: false
};

module.exports = PhoneNumber;


//////////////////
// WEBPACK FOOTER
// ./~/react-phone-number/lib/index.js
// module id = 992
// module chunks = 0